<template>
  <iframe
    :class="[iframeClasses]"
    :width="iframeWidth"
    :height="iframeHeight"
    :src="iframeSrc"
    :title="iframeTitle"
    frameborder="0"
    :allow="iframeAllowData"
    allowfullscreen
  ></iframe>
</template>

<script>
export default {
  name: 'content-in-iframe',
  props: {
    iframeSrc: {
      required: true,
    },
    iframeClasses: {
      required: false,
      default: 'border border-grey-200',
    },
    iframeWidth: {
      required: false,
      default: '300',
    },
    iframeHeight: {
      required: false,
      default: '500',
    },
    iframeTitle: {
      required: true,
    },
    iframeAllowData: {
      required: true,
    },
  },
};
</script>
